module.exports = __webpack_public_path__ + "static/media/Savings-Summary-Icon.2bea7b87.svg";